import enhanceFocuswriterYoutubeEmbed from 'apps/newsletters/posts/util/enhance_focuswriter_youtube_embed';
import enhanceFocuswriterTwitterEmbed from 'apps/newsletters/posts/util/enhance_focuswriter_twitter_embed';
import enhanceFocuswriterTiktokEmbed from 'apps/newsletters/posts/util/enhance_focuswriter_tiktok_embed';

document.addEventListener('DOMContentLoaded', enhanceFocuswriterYoutubeEmbed);
document.addEventListener('DOMContentLoaded', enhanceFocuswriterTwitterEmbed);
document.addEventListener('DOMContentLoaded', enhanceFocuswriterTiktokEmbed);
